import type { CartResponseResponse } from '../../../model/cart/cart';
import type { Currency } from '../../../constants';

export type GetCartResponse = CartResponseResponse;

export type GetCartRequest = {
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type AddToCartRequest = {
  sku: string;
  quantity: number;
  /**
   * WordPress login or guest session cookie key
   */
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type AddToCartResponse = CartResponseResponse;

export type UpdateCartItemRequest = {
  quantity: number;
  itemKey: string;
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type UpdateCartItemResponse = CartResponseResponse;

export type DeleteCartRequest = {
  itemKey: string;
  sessionKey?: string;
  cartToken?: string;
  currency: Currency;
};

export type DeleteCartResponse = CartResponseResponse;
